import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  content: {
    padding: 24
  }
}))
